<div class="page-header">
    <div class="header-fill">
        <img class="logo" src="/Aerostar-Dynamics-Logo-White.png" />
    </div>
    @if (!(isUnknownUser)) {
    <div class="header-account-area">
        <div class="center">
            <button mat-button [matMenuTriggerFor]="user_account"><img src="user-account-icon.svg"></button>
            <mat-menu #user_account="matMenu" yPosition="below">
                <button mat-menu-item (click)="openUserAcctPopup()">View Account</button>
                <button mat-menu-item (click)="openAppInfoPopup()">Application Info</button>
                <button mat-menu-item (click)="navigate('sign-out')">Sign Out</button>
            </mat-menu>
        </div>
    </div>
    }
</div>

<div class="menu-area">
    <div></div> <!-- Buffer between first menu item and edge of window. -->
    @if (userHasRole("sop-viewer")) {
    <button mat-button [matMenuTriggerFor]="operatingProcedures" style="color: white">Standard Operating
        Procedures</button>
    <mat-menu #operatingProcedures="matMenu" yPosition="below">
        @if (userHasRole("sop-editor")) {
        <button mat-menu-item>Download Procedures - Word Form</button>
        <button mat-menu-item>Upload Procedures - Word Form</button>
        <button mat-menu-item>Upload Procedures - PDF Form</button>
        }
        <button mat-menu-item>View Procedures</button>
    </mat-menu>
    }
    @if (userHasRole("manufacturing-info")) {
    <button mat-button [matMenuTriggerFor]="manufacturing" style="color: white">Manufacturing</button>
    <mat-menu #manufacturing="matMenu" yPosition="below">
        <button mat-menu-item [matMenuTriggerFor]="firmwareDownload">Firmware Download</button>
        <button mat-menu-item
            (click)="navigate('view-pdf', ['manufacturing-doc', 'Servos Testing Procedures.pdf'])">Drone Servos Test
            Procedures</button>
    </mat-menu>
    <!--
    ToDo - Relative to the following firmware vehicle and model nested structure...
           Replace the hardcoded nested structure with a nested structure created dynmically from
           the list of folders resident in the Google Storage bucket. See comments in the 
           getFirmwareFolders() function of the home.component.ts for additional information.
    -->
    <mat-menu #firmwareDownload="matMenu" yPosition="below">
        <button mat-menu-item [matMenuTriggerFor]="copter">Copter</button>
        <button mat-menu-item [matMenuTriggerFor]="plane">Plane</button>
    </mat-menu>
    <mat-menu #copter="matMenu" yPosition="below">
        <button mat-menu-item (click)="navigate('view-firmware', ['Copter', 'Scout'])">Scout</button>
        <button mat-menu-item (click)="navigate('view-firmware', ['Copter', 'U55'])">U55</button>
        <button mat-menu-item (click)="navigate('view-firmware', ['Copter', 'Pro'])">Pro</button>
    </mat-menu>
    <mat-menu #plane="matMenu" yPosition="below">
        <button mat-menu-item (click)="navigate('view-firmware', ['Plane', 'VTOL'])">VTOL</button>
    </mat-menu>
    }
    @if (userHasRole("drone-viewer")) {
    <button mat-button style="color: white" (click)="navigate('view-drones')">Drone Registry</button>
    }
    @if (userHasRole("employee-viewer")) {
    <button mat-button style="color: white" (click)="navigate('view-employees')">Employees</button>
    }
    @if (userHasRole("dealer-viewer")) {
    <button mat-button style="color: white" (click)="navigate('view-dealers')">Dealers</button>
    }
    @if (userHasRole("dealer-rep-viewer")) {
    <button mat-button style="color: white" (click)="navigate('view-dealer-reps')">Dealer Reps</button>
    }
    @if (userHasRole("customer-viewer")) {
    <button mat-button style="color: white" (click)="navigate('view-customers')">Customers</button>
    }
    @if (userHasRole("user-software-and-manuals")) {
    <button mat-button style="color: white" (click)="navigate('mission-planner')">Mission Planner Software</button>
    <button mat-button [matMenuTriggerFor]="manuals" style="color: white">Manuals</button>
    <mat-menu #manuals="matMenu" yPosition="below">
        <button mat-menu-item>Scout Operations Manual</button>
        <button mat-menu-item (click)="navigate('view-pdf', ['user-manual', 'U55 Operations Manual.pdf'])">
            U55 Operations Manual
        </button>
        <button mat-menu-item (click)="navigate('view-pdf', ['user-manual', 'Pro Operations Manual.pdf'])">
            Pro Operations Manual
        </button>
        <button mat-menu-item (click)="navigate('view-pdf', ['user-manual', 'Mission Planner User Manual.pdf'])">
            Mission Planner User Manual
        </button>
    </mat-menu>
    }
    <button mat-button [matMenuTriggerFor]="support" style="color: white">Support</button>
    <mat-menu #support="matMenu" yPosition="below">
        @if (userHasRole("log-uploader")) {
        <button mat-menu-item (click)="navigate('upload-log-files')">Upload Log Files</button>
        }
        @if (userHasRole("log-viewer")) {
        <button mat-menu-item (click)="navigate('view-log-files')">View Uploaded Log Files</button>
        }
        <button mat-menu-item>Contact Support</button>
    </mat-menu>
    <div></div> <!-- Buffer between last menu item and edge of window. -->
</div>